/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-05-17 14:20:55
 * description  : 描述
 * author       : zhizhan
 */
import { createScriptFormRemote } from "../../../utils";
import config from "../../../config";

const addHtmlId = function () {
  const body = document.body;
  const widgetId = "__yx_widget";
  let id = body.getAttribute("id") || "";
  if (id.includes("__yx_widget")) {
    return;
  } else {
    id = widgetId;
  }
  const iconFontUrls = { ...config.iconFontUrls };
  delete iconFontUrls.yxWidget;
  createScriptFormRemote(iconFontUrls);
  body.setAttribute("id", id);
};

/**
 *扩展promise的finally
 *
 * @returns
 */
const extraPromise = function () {
  Promise.prototype.finally =
    Promise.prototype.finally ||
    {
      finally(fn) {
        const onFinally = (value) => Promise.resolve(fn()).then(() => value);
        return this.then(
          (result) => onFinally(result),
          (reason) => onFinally(Promise.reject(reason))
        );
      },
    }.finally;
};

const extraArray = function () {
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (handle) {
      for (let index = 0; i < this.length; i++) {
        const item = this[index];
        handle(item, index);
      }
    };
  }
};

const main = function () {
  // console.error("action组件的审核类型已删除");
  // console.warn("审核组件将在未来删除，请谨慎使用");
  // console.warn("审核组件将在未来删除，请谨慎使用");
  // console.warn("审核组件将在未来删除，请谨慎使用");
  // console.warn("审核组件将在未来删除，请谨慎使用");
  addHtmlId();
  extraPromise();
  extraArray();
};

main();



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxComponent/extra/extraJs.js